import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { FlexRow } from 'ui-components/components/flex';
import { Text } from 'ui-components/components/text';
import { useMaxZ } from 'ui-components/hooks/services/use-max-z';

import messages from './messages';
import style from './order-summary.module.less';
import DataDrivenLogo from '../../../../components/data-driven-logo';
import { useEntitiesSalesOrder } from '../../../../hooks/entities/selectors/sales-orders';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';

export const Header = () => {
  const salesOrderId = useSalesOrderIdContext();
  const salesOrder = useEntitiesSalesOrder(salesOrderId) ?? {};
  const { marketplaceId } = salesOrder.store ?? {};
  const zIndex = useMaxZ();
  const zIndexStyle = useMemo(() => ({ zIndex }), [zIndex]);

  return (
    <FlexRow className={style.header} style={zIndexStyle}>
      <FlexRow className={style.left}>
        <DataDrivenLogo className={style['marketplace-icon']} logoType='icon' marketplaceId={Number.parseInt(marketplaceId, 10)} />
        <Text className={style.title} textType='H3' value={<FormattedMessage {...messages.orderSummaryHeader} />} />
      </FlexRow>
    </FlexRow>
  );
};
